@file:Suppress("TooGenericExceptionThrown")

package com.klantenstop.web.data.repos

import com.klantenstop.web.data.NetworkingConfig
import com.klantenstop.web.data.QueryOptions
import com.klantenstop.web.data.getRequest
import com.klantenstop.web.data.models.NetworkResponse
import com.klantenstop.web.data.models.dto.responses.ErrorResponse
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationEntryDetailDto
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationQueueDto
import com.klantenstop.web.data.models.dto.responses.moderation.RejectDecisionDto
import com.klantenstop.web.data.postRequest

object ModerationRepo {
    private val moderationUrl = "${NetworkingConfig.baseUrl}/api/v1/moderation"

    suspend fun getCompanyQueue(page: Int = 1, pageSize: Int = 5): ModerationQueueDto =
        fetchQueue("$moderationUrl/companies", page, pageSize)

    suspend fun getStatusQueue(page: Int = 1, pageSize: Int = 5): ModerationQueueDto =
        fetchQueue("$moderationUrl/statuses", page, pageSize)

    suspend fun getReviewQueue(page: Int = 1, pageSize: Int = 5): ModerationQueueDto =
        fetchQueue("$moderationUrl/reviews", page, pageSize)

    suspend fun getEntryDetail(entryId: String): ModerationEntryDetailDto {
        val url = "$moderationUrl/$entryId"
        val response: NetworkResponse<ModerationEntryDetailDto, ErrorResponse> = getRequest(url)
        return when (response) {
            is NetworkResponse.Success -> response.body
            is NetworkResponse.ServerError -> throw Exception(response.body?.errorDescription ?: "Server fout bij ophalen entry detail")
            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij ophalen entry detail")
        }
    }

    suspend fun approveEntry(entryId: String) {
        val url = "$moderationUrl/$entryId/approve"
        val response: NetworkResponse<Unit, ErrorResponse> = postRequest(url, Unit)
        return when (response) {
            is NetworkResponse.Success -> Unit
            is NetworkResponse.ServerError -> throw Exception(response.body?.errorDescription ?: "Server fout bij goedkeuren entry")
            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij goedkeuren entry")
        }
    }

    suspend fun rejectEntry(entryId: String, reason: String) {
        val url = "$moderationUrl/$entryId/reject"
        val body = RejectDecisionDto(rejectionReason = reason)
        val response: NetworkResponse<Unit, ErrorResponse> = postRequest(url, body)
        return when (response) {
            is NetworkResponse.Success -> Unit
            is NetworkResponse.ServerError -> throw Exception(response.body?.errorDescription ?: "Server fout bij afkeuren entry")
            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij afkeuren entry")
        }
    }

    private suspend fun fetchQueue(url: String, page: Int, pageSize: Int): ModerationQueueDto {
        val queryOptions = QueryOptions(params = mapOf("page" to page.toString(), "pageSize" to pageSize.toString()))
        val response: NetworkResponse<ModerationQueueDto, ErrorResponse> = getRequest(url, queryOptions = queryOptions)
        return when (response) {
            is NetworkResponse.Success -> response.body
            is NetworkResponse.ServerError -> throw Exception(response.body?.errorDescription ?: "Server fout")
            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout")
        }
    }
}
